import React, { lazy, Suspense, useEffect, useState } from 'react';
import { BmsAssistsMicroFrontendProps } from './BmsAssistsMicroFrontend';
import { User } from 'oidc-client';
import authService from '../../authService';
import './BmsAssists.scss';

const BmsAssistsMicroFrontend = lazy(() =>
  import('./BmsAssistsMicroFrontend').then((m) => ({
    default: m.BmsAssistsMicroFrontend
  }))
);

const BmsAssistsMicroFrontendPage: React.FC<BmsAssistsMicroFrontendProps> = (
  props
) => {
  const [accessToken, setAccessToken] = useState<string>(props.accessToken || '');

   useEffect(() => {
    // Fetch token on mount
    authService.getUser().then(user => {
      if (user?.access_token) {
        setAccessToken(user.access_token);
      }
    });

    // Automatically update token whenever OIDC silently renews it
    const onUserLoaded = (user: User) => {
      if (user?.access_token) {
        setAccessToken(user.access_token);
      }
    };

    authService.userManager.events.addUserLoaded(onUserLoaded);

    return () => {
      authService.userManager.events.removeUserLoaded(onUserLoaded);
    };
  }, []);

  return (
    <div id="bms-assists-micro-frontend">
      <Suspense fallback={null}>
        <BmsAssistsMicroFrontend {...props} accessToken={accessToken}/>
      </Suspense>
    </div>
  );
};

export default BmsAssistsMicroFrontendPage;